export default {"src":"/_next/static/media/INVH.1faabaf2.svg","height":18,"width":18};